<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">

    <!-- HEADER BAR -->
    <div class="p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <h6 class="mb-0 fw-bold">Liste des colis</h6>

        <button
          class="btn btn-sm btn-outline-primary position-relative"
          @click="filtersOpen = !filtersOpen"
        >
          <i class="flaticon-filter me-1"></i> Filtres
          <span
            v-if="activeFilterCount > 0"
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style="font-size:10px"
          >{{ activeFilterCount }}</span>
        </button>

        <button
          v-if="activeFilterCount > 0"
          class="btn btn-sm btn-outline-secondary"
          @click="resetFilters"
        >
          <i class="flaticon-close me-1"></i> Réinitialiser
        </button>

        <button
          v-if="followupCount > 0 || filter.searchFollowup"
          class="btn btn-sm relaunch-filter"
          :class="{ 'is-active': filter.searchFollowup }"
          :aria-pressed="!!filter.searchFollowup"
          @click="toggleFollowupFilter"
        >
          <i class="ph ph-arrow-clockwise me-1"></i> À relancer
          <span class="badge rounded-pill ms-1">{{ followupCount }}</span>
        </button>
      </div>

      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div class="position-relative">
          <i class="flaticon-search position-absolute top-50 translate-middle-y" style="left:10px; opacity:0.4; pointer-events:none;"></i>
          <input
            type="text"
            class="form-control form-control-sm rounded-1"
            style="min-width:240px; padding-left:32px;"
            placeholder="Code, téléphone, destinataire..."
            v-model="searchTerm"
            @input="handleInput"
          />
        </div>

        <button
          v-if="auth.can('EXPORT_PARCELS')"
          class="btn btn-sm btn-outline-success"
          @click="exportColis"
        >
          <i class="flaticon-file-1 me-1"></i> Export
        </button>
      </div>
    </div>

    <!-- ACTIVE FILTER CHIPS -->
    <div
      v-if="activeFilterCount > 0 && !filtersOpen"
      class="px-15 px-md-20 py-10 border-bottom d-flex flex-wrap gap-2 align-items-center"
    >
      <span class="text-muted fs-13 me-1">Filtres actifs :</span>
      <span v-if="client_filter?.name" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ client_filter.name }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('client')"></i>
      </span>
      <span v-if="zone_filter?.name" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ zone_filter.name }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('zone')"></i>
      </span>
      <span v-if="city_filter?.name" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ city_filter.name }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('city')"></i>
      </span>
      <span v-if="liv_filter?.name" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ liv_filter.name }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('liv')"></i>
      </span>
      <span v-if="etat_filter" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ etat_filter }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('etat')"></i>
      </span>
      <span v-if="status_filter?.name" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ status_filter.name }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('status')"></i>
      </span>
      <span v-if="date_from" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1">
        {{ date_from }} – {{ date_to || "..." }}
        <i class="ph ph-x" style="cursor:pointer" @click="removeOneFilter('date')"></i>
      </span>
    </div>

    <!-- COLLAPSIBLE FILTERS PANEL -->
    <div v-show="filtersOpen" class="border-bottom bg-light px-15 px-md-20 py-15">
      <div class="row g-3 align-items-end">

        <div class="col-sm-6 col-lg-4">
          <label class="form-label fw-medium fs-13 mb-1">Magasin</label>
          <v-select v-model="client_filter" label="name" :options="clientList" @search="filterClients" placeholder="Tous" />
        </div>

       

        <div class="col-sm-6 col-lg-4">
          <label class="form-label fw-medium fs-13 mb-1">Ville</label>
          <v-select v-model="city_filter" label="name" :options="citiesList" placeholder="Toutes" />
        </div>

       
        <div class="col-sm-6 col-lg-4">
          <label class="form-label fw-medium fs-13 mb-1">État</label>
          <v-select v-model="etat_filter" label="name" :options="etatList" placeholder="Tous" />
        </div>

        <div class="col-sm-6 col-lg-4">
          <label class="form-label fw-medium fs-13 mb-1">Status</label>
          <v-select v-model="status_filter" label="name" :options="status" placeholder="Tous" />
        </div>


        <div class="col-sm-6 col-lg-4">
          <label class="form-label fw-medium fs-13 mb-1">Période</label>
          <div
            class="form-control form-control-sm d-flex align-items-center justify-content-between"
            style="cursor:pointer"
            @click="showCalendar()"
          >
            <span>
              {{ selectedDate?.[0]?.format("DD MMM YYYY") || "Date début" }}
              –
              {{ selectedDate?.[1]?.format("DD MMM YYYY") || "Date fin" }}
            </span>
            <i class="flaticon-calendar"></i>
          </div>
          <div v-show="showCalendarBox" class="position-absolute mt-1 p-2 bg-white shadow rounded" style="z-index:999">
            <MyDateRangePicker v-model="selectedDate" @onSelect="showCalendar" :enableSecondCalendar="true" />
          </div>
        </div>

        

      </div>

      <div class="d-flex gap-2 mt-15 pt-10 border-top">
        <button class="btn btn-primary btn-sm px-4" @click="applyFilters(); filtersOpen = false">
          <i class="flaticon-filter me-1"></i> Appliquer
        </button>
        <button class="btn btn-outline-secondary btn-sm px-4" @click="resetFilters(); filtersOpen = false">
          <i class="flaticon-close me-1"></i> Réinitialiser
        </button>
        <button class="btn btn-link btn-sm text-muted ms-auto" @click="filtersOpen = false">
          Fermer
        </button>
      </div>
    </div>

   <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0" style="min-width: 900px;">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Dernière mise à jour
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Destinataire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Magasin
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Etat
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ville
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prix
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ACTIONS
              </th>

              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                BONS
              </th> -->
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, index) in rows" :key="index">
            <tr :class="{ 'relaunch-row': row.followup_comment !== null && row.followup_comment !== undefined }">
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <span
                  v-if="row.followup_comment !== null && row.followup_comment !== undefined"
                  class="relaunch-badge mb-2"
                >
                  <i class="ph ph-arrow-clockwise"></i> À relancer
                </span>
                <div class="d-flex align-items-center">
                  <h6 v-if="row.replace === 1" class="text-warning">
                    {{ row.code }}
                    <i class="ph ph-repeat"></i>
                  </h6>
                  <h6 v-else-if="row.partial === 1" class="text-info">
                    {{ row.code }}
                    <i class="ph ph-arrows-down-up"></i>
                  </h6>
                  <h6 v-else>
                    {{ row.code }}
                  </h6>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(row.updated_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p class="text-nowrap">
                  <b>{{ row.receiver }}</b> <br />
                  <b>{{ oldPhone(row.phone) }}</b> <br />
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b v-if="row.magasin_name"> {{ row.magasin_name }} </b>

                <div v-else class="text-nowrap">
                  <br />
                  {{ row.customer_name }}<br />
                  {{ oldPhone(row.customer_phone) }}
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  :class="`badge text-outline-${resolveUserStatusVariant(
                    row.situation
                  )}`"
                >
                  {{ resolveStatuParcel(row.situation) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div
                  v-if="
                    row.status == 'IN_PROGRESS' &&
                    row.status_second &&
                    globalHelper(row.status_second)?.name
                  "
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{
                    '--dynamic-bg': globalHelper(row.status_second)?.code_color,
                  }"
                >
                  <!-- {{ GetStatus(row.status_second)}} -->
                  <template
                    v-if="
                      row.status_second == 'POSTPONED' ||
                      row.status_second == 'PROGRAMED'
                    "
                  >
                    <!-- {{ resolveStatuParcel(row.status_second) }} -->
                    {{ globalHelper(row.status_second)?.name }}
                    <br />
                    {{ row.reported_date }}
                  </template>

                  <template v-else>
                    {{ globalHelper(row.status_second)?.name }}
                  </template>
                </div>

                <div
                  v-else-if="
                    row.status == 'RETURNED' &&
                    (!row.status_second || row.status_second != 'REFUSE') &&
                    row.last_statut_comment
                  "
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': row.code_color }"
                >
                  {{ row.s_name }}<br />
                  - {{ row.last_statut_comment }}
                </div>
                <div
                  v-else-if="
                    row.status == 'RETURNED' &&
                    row.status_second == 'REFUSE' &&
                    globalHelper(row.status_second)?.name
                  "
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{
                    '--dynamic-bg': globalHelper(row.status_second)?.code_color,
                  }"
                >
                  Retourné - {{ globalHelper(row.status_second)?.name }}
                </div>

                <div
                  v-else
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': row.code_color }"
                >
                  {{ row.s_name }}
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.city_name }}</b
                ><br />
                <!-- <p v-if="row.quartier && row.quartier.name">
                  {{ row.quartier.name }}
                </p> -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.price }} </b>{{ $devis }}<br />
              </td>

              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- Historique -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetailSuivi(row)"
                      >
                        <i
                          class="flaticon-clock lh-1 me-8 position-relative top-1"
                        ></i>
                        Historique
                      </button>
                    </li>

                    <!-- Infos -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </button>
                    </li>

                    <li
                      v-if="
                        row.status == 'DISTRIBUTION' ||
                        (row.status == 'IN_PROGRESS' && row.invoiced == 0)
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        :href="`tel:` + SubstrPhone(row.phone)"
                      >
                        <i class="flaticon-phone-call"></i>
                        Appeler Destinataire
                      </a>
                    </li>

                    <!-- <li
                      v-if="
                        row.status == 'DISTRIBUTION' ||
                        (row.status == 'IN_PROGRESS' && row.invoiced == 0)
                      "
                    >
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="smsTextreplace(row, 'NO_ANSWER')"
                        variant="success"
                      >
                        <i
                          class="ph ph-whatsapp-logo lh-1 me-8 position-relative top-1"
                        ></i>
                        Whatsapp
                      </button>
                    </li> -->

                    <!-- WhatsApp Share -->
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        target="_blank"
                        :href="`https://api.whatsapp.com/send?phone=${SubstrPhone(
                          row.phone
                        )}&text=Client : ${row.customer_name} Téléphone : ${
                          row.customer_phone
                        } Code d'envoi : ${row.code} Destinataire : ${
                          row.receiver
                        } Téléphone : ${row.phone} Ville : ${
                          row.city_name
                        } Adresse : ${row.address} Commentaire : ${
                          row.note
                        } Produit : ${row.product_nature} Crbt : ${
                          row.price
                        } ${$devis}`"
                      >
                        <i
                          class="ph ph-whatsapp-logo lh-1 me-8 position-relative top-1"
                        ></i>
                        WhatsApp
                      </a>
                    </li>

                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="ShareCust(row)"
                      >
                        <i
                          class="flaticon-send lh-1 me-8 position-relative top-1"
                        ></i>
                        Partager avec vendeur
                      </a>
                    </li>

                    <li
                      v-if="
                        auth.can('PARCELS') &&
                        user?.role_id === 3 &&
                        row.status !== 'NEW_PARCEL' &&
                        row.status !== 'WAITING_PICKUP' &&
                        row.status !== 'RETURNED' &&
                        row.status !== 'RETURNED_PARTIAL'
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="showUpdate(row)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>

                    <!-- Status Actions -->
                    <li
                      v-if="
                        row.status === 'DISTRIBUTION' ||
                        (row.status === 'IN_PROGRESS' && row.invoiced === 0)
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="showStatus(row.id)"
                      >
                        <i
                          class="flaticon-edit lh-1 me-8 position-relative top-1"
                        ></i>
                        Changer Status
                      </a>
                    </li>
                  </ul>
                </div>
              </td>

              <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis"></td> -->
            </tr>
            <!-- Suivi et relance: comment of the vendor, to read before the new attempt -->
            <tr
              v-if="row.followup_comment !== null && row.followup_comment !== undefined"
              class="relaunch-comment-row"
            >
              <td colspan="9" class="ps-0">
                <div class="relaunch-comment">
                  <i class="ph ph-chat-circle-text" aria-hidden="true"></i>
                  <div>
                    <small>Commentaire de suivi du vendeur · relancé le {{ getDate(row.followup_relaunched_at) }}</small>
                    <p>{{ row.followup_comment || "—" }}</p>
                  </div>
                  <button
                    v-if="row.status === 'DISTRIBUTION' || (row.status === 'IN_PROGRESS' && row.invoiced === 0)"
                    type="button"
                    class="btn btn-sm btn-primary ms-auto"
                    @click="showStatus(row.id)"
                  >
                    Mettre à jour le statut
                  </button>
                </div>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-20 pt-15 border-top">

        <!-- Per page selector -->
        <div class="d-flex align-items-center gap-2">
          <span class="text-muted small">Afficher</span>
          <select
            class="form-select form-select-sm w-auto"
            v-model="filter.per_page"
            @change="changePerPage"
          >
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span class="text-muted small">lignes</span>
        </div>

        <!-- Result info -->
        <p class="mb-0 text-muted small">
          <span class="fw-semibold text-dark">{{ (filter.current_page - 1) * filter.per_page + 1 }}</span>
          –
          <span class="fw-semibold text-dark">{{ Math.min(filter.current_page * filter.per_page, filter.total) }}</span>
          sur
          <span class="fw-semibold text-dark">{{ filter.total }}</span>
          résultats
        </p>

        <!-- Page nav -->
        <nav aria-label="Pagination">
          <ul class="pagination pagination-sm mb-0 gap-1">
            <li class="page-item" :class="{ disabled: filter.current_page === 1 }">
              <a class="page-link rounded-1" href="javascript:void(0)" @click="goToPage(filter.current_page - 1)" aria-label="Précédent">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>

            <template v-for="(page, index) in paginatedPages" :key="index">
              <li v-if="page === '...'" class="page-item disabled">
                <span class="page-link rounded-1 border-0 bg-transparent">…</span>
              </li>
              <li v-else class="page-item" :class="{ active: filter.current_page === page }">
                <a href="javascript:void(0)" class="page-link rounded-1" @click="goToPage(page as number)">
                  {{ page }}
                </a>
              </li>
            </template>

            <li class="page-item" :class="{ disabled: filter.current_page === filter.last_page }">
              <a class="page-link rounded-1" href="javascript:void(0)" @click="goToPage(filter.current_page + 1)" aria-label="Suivant">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>


  <!-- Status Update Modal using Bootstrap -->
  <div
    class="modal fade"
    id="modal_update_status"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Changer le statut du colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="statusFollowupComment !== null" class="relaunch-comment mb-3">
            <i class="ph ph-arrow-clockwise" aria-hidden="true"></i>
            <div>
              <small>À relancer — commentaire de suivi du vendeur</small>
              <p>{{ statusFollowupComment || "—" }}</p>
            </div>
          </div>
          <form>
            <!-- Statut -->
            <div class="mb-3">
              <label for="statut" class="form-label">Statut</label>
              <v-select
                class="custom-select-height"
                id="statut"
                v-model="statutColi"
                label="name"
                placeholder="Choisir un statut"
                :options="statusList"
              />
            </div>
            <!-- Commentaire -->
            <div class="mb-3">
              <label for="note" class="form-label">Commentaire</label>
              <textarea
                v-model="commentStatu"
                name="note"
                rows="3"
                class="form-control"
                placeholder="Écrire un commentaire ici..."
              ></textarea>
            </div>
            <!-- Date le (if POSTPONED or PROGRAMED) -->
            <div
              class="mb-3"
              v-if="
                statutColi.code === 'POSTPONED' ||
                statutColi.code === 'PROGRAMED'
              "
            >
              <label for="datepicker-dateformat2" class="form-label"
                >Date le :</label
              >
              <input
                type="date"
                id="datepicker-dateformat2"
                v-model="date_retour"
                class="form-control"
                :min="minDate"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            v-if="auth.can('PARCELS')"
            type="button"
            class="btn btn-primary"
            @click="editPriceStatut"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Status Update Modal using Bootstrap -->
  <div
    class="modal fade"
    id="modal_detail_suivi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Historique Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <HistoryColis
            v-if="colisId"
            :colisId="colisId"
            :isOpen="isOpen"
            :status="status"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Parcel Modal using Bootstrap -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRecords"
            :isOpenEdit="isOpenEdit"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modalExortToday"
    tabindex="-1"
    ref="reportedModal"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Colis reportés aujourd’hui</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <!-- Loader -->
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-warning"></div>
            <p class="mt-2">Chargement...</p>
          </div>

          <!-- Table -->
          <div v-else-if="parcels.length" class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Client</th>
                  <th>Destinataire</th>
                  <th>Téléphone</th>
                  <th>Ville</th>
                  <th>Prix</th>
                  <th>Date report</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in parcels" :key="item.id">
                  <td>{{ item.code }}</td>
                  <td>{{ item.store ?? "-" }}</td>
                  <td>{{ item.receiver }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.city_name }}</td>
                  <td>{{ item.price }} {{ $devis }}</td>
                  <td>{{ item.reported_date }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Empty -->
          <div v-else class="text-center text-muted">Aucun colis trouvé.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { computed, nextTick, onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { currency } from "@/utils/currency";
import moment from "moment";
import HistoryColis from "@/components/Colis/HistoryColis.vue";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import DetailsColis from "@/components/Colis/DetailsColis.vue";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

import { Modal } from "bootstrap";
import Swal from "sweetalert2";

export default {
  name: "ColisList",
  components: {
    HistoryColis,
    DetailsColis,
    UpdateParcel,
    MyDateRangePicker
  },
  setup: () => {
    const { showToast } = useAppToast();
    const leadPlaceholder = "Select Lead Date";
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const direction = ref(true); // if you use RTL boolean; adjust to your prop type
    const isLoader = ref(false);
    const countExportToday = ref(0);

    const minDate = ref(
      moment(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        )
      ).format("YYYY-MM-DD")
    );

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchTerm: "",
      searchCustomer: "",
      searchZone: "",
      searchLiv: "",
      searchCity: "",
      searchEtat: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchTypeDate: "",
      searchBPL: "",
      searchRef: "",
      searchEmail: "",
      searchPrice: "",
      searchFollowup: "",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const zone_filter = ref({ id: "", name: "" });
    const client_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref({ id: "", name: "", code: "" });

    const etat_filter = ref("");
    const type_date_filter = ref("");
    const add_bp_filter = ref("");
    const ref_filter = ref("");
    const email_filter = ref("");
    const price_filter = ref("");
    const searchTerm = ref("");

    const filtersOpen = ref(false);
    const date_from = ref("");
    const date_to = ref("");

    const activeFilterCount = computed(() => {
      let n = 0;
      if (client_filter.value?.id) n++;
      if (zone_filter.value?.id) n++;
      if (city_filter.value?.id) n++;
      if (liv_filter.value?.id) n++;
      if (etat_filter.value) n++;
      if (status_filter.value?.code) n++;
      if (date_from.value) n++;
      if (add_bp_filter.value) n++;
      return n;
    });

    const coliDetails = ref<any>({});
    const statutColi = ref<any>({});
    const commentStatu = ref("");
    const date_retour = ref("");
    const statuColisID = ref(0);

    const formStatus = reactive({
      id: 0,
      status: "",
      status_id: 0,
      comment: "",
    });

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);
    const statusList = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const zonesList = ref<Status[]>([]);
    const citiesList = ref<Status[]>([]);
    const livreurList = ref<Status[]>([]);
    const etatList = ref(["Tous", "Non Payé", "Payé", "Facturé"]);

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);
    const showCalendarBox = ref(false);

    function showCalendar() {
      showCalendarBox.value = !showCalendarBox.value;
    }

    function convert(date) {
      // example: to YYYY-MM-DD (adapt to your backend)
      const d = new Date(date);
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    }

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",
        searchCustomer: filter.searchCustomer || "",
        searchZone: filter.searchZone || "",
        searchLiv: filter.searchLiv || "",
        searchCity: filter.searchCity || "",
        searchEtat: filter.searchEtat || "",
        searchStatut: filter.searchStatut || "",
        searchSDate: filter.searchSDate || "",
        searchEDate: filter.searchEDate || "",
        searchTypeDate: filter.searchTypeDate || "",
        searchBPL: filter.searchBPL || "",
        searchRef: filter.searchRef || "",
        searchEmail: filter.searchEmail || "",
        searchPrice: filter.searchPrice || "",
        searchFollowup: filter.searchFollowup || "",
        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/colis_list?${params.toString()}`;
    }

    onMounted(async () => {
      getRecords();
      fetchStatus();

      try {
        const { data } = await api.get(`/api/auth/listCities`);

        if (Array.isArray(data)) {
          citiesList.value = data;

          // Évite les doublons
          if (
            !citiesList.value.some(
              (city) => city.code === "0" && city.name === "Tous"
            )
          ) {
            citiesList.value.unshift({ code: "0", name: "Tous" });
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des villes :", error);
        // showToast("Impossible de charger la liste des villes", "error")
      }

      try {
        const response = await api.get(`/api/auth/fetEditchStatu`);
        if (response && response.data) {
          statusList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });
    const debounceTimer = ref<number | undefined>(undefined);

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = window.setTimeout(() => {
        filter.searchTerm = searchTerm.value;
        filter.current_page = 1;
        getRecords();
      }, 500);
    }

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })

        countExportToday.value = data.exported;
        followupCount.value = Number(data.users.followupCount || 0);
      } finally {
        isLoader.value = false;
      }
    }

    function applyFilters() {
      if (selectedDate.value?.[0]) {
        date_from.value = selectedDate.value[0].format("YYYY-MM-DD");
        date_to.value = selectedDate.value[1]?.format("YYYY-MM-DD") || "";
      } else {
        date_from.value = "";
        date_to.value = "";
      }
      filter.searchZone = zone_filter.value?.id || "";
      filter.searchCustomer = client_filter.value?.id || "";
      filter.searchLiv = liv_filter.value?.id || "";
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";
      filter.searchSDate = date_from.value || "";
      filter.searchEDate = date_to.value || "";
      filter.searchTypeDate = type_date_filter.value || "";
      filter.searchBPL = add_bp_filter.value || "";
      filter.searchRef = ref_filter.value || "";
      filter.searchEmail = email_filter.value || "";
      filter.searchTerm = searchTerm.value || "";
      filter.searchPrice = price_filter.value || "";
      filter.current_page = 1;
      getRecords();
    }

    // « À relancer »: parcels relaunched by the admin (Suivi et relance des colis)
    const followupCount = ref(0);
    function toggleFollowupFilter() {
      filter.searchFollowup = filter.searchFollowup ? "" : "1";
      filter.current_page = 1;
      getRecords();
    }
    const statusFollowupComment = computed(() => {
      const row = (rows.value as any[]).find((r) => r.id === formStatus.id);
      return row && row.followup_comment !== null && row.followup_comment !== undefined ? row.followup_comment : null;
    });

    function resetFilters() {
      filter.searchZone = ""; filter.searchCustomer = ""; filter.searchPrice = ""; filter.searchFollowup = "";
      filter.searchLiv = ""; filter.searchCity = ""; filter.searchEtat = "";
      filter.searchStatut = ""; filter.searchSDate = ""; filter.searchEDate = "";
      filter.searchTypeDate = ""; filter.searchBPL = ""; filter.searchRef = "";
      filter.searchEmail = ""; filter.searchTerm = ""; filter.current_page = 1;
      etat_filter.value = ""; add_bp_filter.value = ""; ref_filter.value = "";
      email_filter.value = ""; type_date_filter.value = ""; price_filter.value = "";
      searchTerm.value = ""; date_from.value = ""; date_to.value = "";
      selectedDate.value = null;
      zone_filter.value = { id: "", name: "" };
      client_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      city_filter.value = { id: "", name: "" };
      status_filter.value = { id: "", name: "", code: "" };
      getRecords();
    }

    function removeOneFilter(key: string) {
      if (key === "client") { client_filter.value = { id: "", name: "" }; filter.searchCustomer = ""; }
      else if (key === "zone") { zone_filter.value = { id: "", name: "" }; filter.searchZone = ""; }
      else if (key === "city") { city_filter.value = { id: "", name: "" }; filter.searchCity = ""; }
      else if (key === "liv") { liv_filter.value = { id: "", name: "" }; filter.searchLiv = ""; }
      else if (key === "etat") { etat_filter.value = ""; filter.searchEtat = ""; }
      else if (key === "status") { status_filter.value = { id: "", name: "", code: "" }; filter.searchStatut = ""; }
      else if (key === "date") { date_from.value = ""; date_to.value = ""; filter.searchSDate = ""; filter.searchEDate = ""; }
      filter.current_page = 1;
      getRecords();
    }

    async function exportColis() {
      filter.searchZone = zone_filter.value?.id || "";
      filter.searchCustomer = client_filter.value?.id || "";
      filter.searchLiv = liv_filter.value?.id || "";
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";

      //   filter.searchSDate = myInput.value?.dateRange?.start
      //     ? convert(myInput.value.dateRange.start)
      //     : "";
      //   filter.searchEDate = myInput.value?.dateRange?.end
      //     ? convert(myInput.value.dateRange.end)
      //     : "";

      filter.searchTypeDate = type_date_filter.value || "";
      filter.searchBPL = add_bp_filter.value || "";
      filter.searchRef = ref_filter.value || "";
      filter.searchEmail = email_filter.value || "";
      filter.searchTerm = searchTerm.value || "";
      filter.searchPrice = price_filter.value || "";

      try {
        const res = await api.get(
          `/api/auth/ExportColis?searchTerm=${filter.searchTerm}&searchCustomer=${filter.searchCustomer}&searchZone=${filter.searchZone}&searchLiv=${filter.searchLiv}&searchCity=${filter.searchCity}&searchEtat=${filter.searchEtat}&searchStatut=${filter.searchStatut}&searchSDate=${filter.searchSDate}&searchEDate=${filter.searchEDate}&searchTypeDate=${filter.searchTypeDate}&searchBPL=${filter.searchBPL}`,
          { responseType: "arraybuffer" }
        );

        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ExportColis.xlsx";
        fileLink.click();
      } catch (error) {
        if (error.response) {
          // Erreur serveur (ex: 500)
          console.error(
            "Erreur serveur :",
            error.response.status,
            error.response.data
          );
          // Exemple toast ou showToaste
          // showToast("Une erreur serveur est survenue lors de l’export (500)", "error");
          showToast(
            "Une erreur serveur est survenue lors de l’export.",
            "error"
          );
        } else if (error.request) {
          // Pas de réponse du serveur
          console.error("Aucune réponse du serveur :", error.request);
          showToast(
            "Impossible de contacter le serveur. Vérifiez votre connexion.",
            "error"
          );
        } else {
          // Erreur autre (ex: code JS)
          console.error("Erreur lors de la requête :", error.message);
          showToast("Une erreur inattendue est survenue.", "error");
        }
      }
    }

    async function fetchStatus() {
      try {
        const response = await api.get("/api/auth/AllStatus");
        if (response && response.data) {
          status.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function changePerPage() {
      filter.current_page = 1;
      getRecords();
    }

    const paginatedPages = computed(() => {
      const total = filter.last_page;
      const current = filter.current_page;
      const pages: (number | string)[] = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
        return pages;
      }

      pages.push(1);
      if (current > 3) pages.push("...");

      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);
      for (let i = start; i <= end; i++) pages.push(i);

      if (current < total - 2) pages.push("...");
      pages.push(total);

      return pages;
    });

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }
    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }

      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    function formatReported(row: any) {
      return removeHours(row.reported_date);
    }

    // Decide what to show in badge
    function getBadgeConfig(row: any) {
      // IN_PROGRESS with secondary status
      if (
        row.status === "IN_PROGRESS" &&
        row.status_second &&
        getStatusName(row.status_second)
      ) {
        if (
          ["POSTPONED", "PROGRAMED", "POSTPONED_TODAY"].includes(
            row.status_second
          )
        ) {
          return {
            text: getStatusName(row.status_second),
            date: formatReported(row),
            color: reported(row.reported_date)
              ? "#E50A0A"
              : getStatusColor(row.status_second),
          };
        }
        return {
          text: getStatusName(row.status_second),
          color: getStatusColor(row.status_second),
        };
      }

      // RETURNED but not REFUSE
      if (
        row.status === "RETURNED" &&
        (!row.status_second || row.status_second !== "REFUSE") &&
        row.last_statut_comment
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `${row.statut.s_name} Endommagé`
              : row.statut.s_name,
          comment: row.last_statut_comment,
          color: row.statut.code_color,
        };
      }

      // RETURNED with REFUSE
      if (
        row.status === "RETURNED" &&
        row.status_second === "REFUSE" &&
        getStatusName(row.status_second)
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `Retourné Endommagé - ${getStatusName(row.status_second)}`
              : `Retourné - ${getStatusName(row.status_second)}`,
          comment: row.last_statut_comment,
          color: getStatusColor(row.status_second),
        };
      }

      // Default
      return {
        text:
          row.rn_e && row.rn_e !== 0 && row.status === "RETURNED"
            ? `${row.statut.s_name} Endommagé`
            : row.statut.s_name,
        color: row.statut.code_color,
      };
    }

    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(searchTimeout)
    //   searchTimeout = setTimeout(() => {
    //     filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    async function onSearchDrivers(
      search: string,
      loading: { value: boolean }
    ) {
      const query = search.trim().toLowerCase();

      if (!query) {
        livreurList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/LivsList`, {
            params: { query },
          });
          livreurList.value = res.data;
          livreurList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          livreurList.value = [];
        }
      }, 300); // 300ms debounce
    }

    async function reportTodayColis() {
      try {
        const res = await api.get(`/api/auth/TodayExportColis`, {
          responseType: "arraybuffer",
        });

        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ExportReportedColis.xlsx";
        fileLink.click();
      } catch (error) {
        if (error.response) {
          // Erreur serveur (ex: 500, 404...)
          console.error(
            "Erreur serveur :",
            error.response.status,
            error.response.data
          );
          showToast(
            `Erreur serveur (${error.response.status}) lors de l’export des colis.`,
            "error"
          );
        } else if (error.request) {
          // Aucune réponse du serveur
          console.error("Aucune réponse du serveur :", error.request);
          showToast(
            "Impossible de contacter le serveur. Vérifiez votre connexion.",
            "error"
          );
        } else {
          // Erreur autre (JS, Axios config, etc.)
          console.error("Erreur lors de la requête :", error.message);
          showToast(
            "Une erreur inattendue est survenue lors de l’export.",
            "error"
          );
        }
      }
    }

    const showRefs = ref(true);
    function showRefsEdit() {
      if (ref_filter.value == "1") {
        showRefs.value = true;
      } else {
        showRefs.value = false;
      }
    }

    // Mapping type to endpoint
    const pdfEndpoints = {
      1: "DELPDF",
      2: "DeliveryPDF",
      3: "SentPDF",
      4: "DISTPDF",
      5: "InvoicePdf",
      6: "PAYMPDF",
      7: "ReturnPDF",
      8: "ReturnPDF",
      9: "PonitPDF",
      10: "ArrivagePDF",
    };

    async function showParcelBons(row) {
      try {
        const res = await api.get(`/api/auth/BonsParcel/${row.id}`);
        if (res.data.msg === "success") {
          row.bons = res.data.data;
          row.showButtons = 1;
        }
      } catch (error) {
        console.error(error);
        showToast("Erreur lors de la récupération des bons", "error");
      }
    }

    async function voirItem(item, type) {
      const endpoint = pdfEndpoints[type];
      if (!endpoint) {
        console.warn(`PDF type "${type}" non géré`);
        return;
      }

      try {
        const res = await api.get(`/api/auth/${endpoint}/${item}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
        // Optional: download automatically
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = `${item}.pdf`;
        // link.click();
      } catch (error) {
        console.error(error);
        showToast("Erreur lors du téléchargement du PDF", "error");
      }
    }

    const PriceColis = ref(null);

    // -------------------------------
    // Function to generate PDF ticket
    async function TicketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketParcelPDF/${row.id}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        // Optionally, revoke the object URL after some time
        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
      } catch (error) {
        console.error("Erreur lors du téléchargement du ticket PDF:", error);
        showToast("Erreur lors du téléchargement du ticket PDF", "error");
      }
    }

    // -------------------------------
    // Function to show parcel history
    const colisId = ref(null);
    const isOpen = ref(false);

    async function showDetailSuivi(row) {
      isOpen.value = false;
      colisId.value = null;

      // wait for Vue to register the reset
      await nextTick();

      colisId.value = row.id;
      isOpen.value = true;

      await nextTick(); // ensure DOM update before showing modal

      const modalEl = document.getElementById("modal_detail_suivi");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
    }

    // -------------------------------
    // Function to show parcel info

    async function showDetails(row) {
      isOpen.value = false;
      coliDetails.value = null; // reset first

      await nextTick(); // wait for reset to flush

      coliDetails.value = row; // assign new data
      isOpen.value = true;

      await nextTick(); // ensure reactivity + DOM update

      const modalEl = document.getElementById("modal_detail_colis");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
    }

    // -------------------------------
    // Function to edit parcel
    async function editParcel(_row: any) {
      // TODO: Open edit modal
    }

    // -------------------------------
    // Function to format phone for WhatsApp
    function SubstrPhone(phone: string): string {
      return phone?.startsWith("0") ? "212" + phone.slice(1) : (phone || "");
    }

    // -------------------------------
    // Share parcel with seller
    async function ShareCust(row) {
      try {
        const res = await api.get(`/api/auth/SearchPhone`, {
          params: { type: 1, code: row.code },
        });
        if (res.data.msg === "success") {
          const phone = SubstrPhone(res.data.user.phone);
          const message = [
            `Client : ${res.data.user.store}`,
            `Téléphone : ${row.customer_phone}`,
            `Code d'envoi : ${row.code}`,
            `Destinataire : ${row.receiver}`,
            `Téléphone : ${row.phone}`,
            `Ville : ${row.city_name}`,
            `Adresse : ${row.address}`,
            `Commentaire : ${row.note}`,
            `Produit : ${row.product_nature}`,
            `Crbt : ${row.price} ${currency()}`,
          ].join("\n");
          window.open(
            `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
              message
            )}`,
            "_blank"
          );
        }
      } catch (error) {
        console.error("Erreur lors du partage avec vendeur :", error);
      }
    }

    async function ShareLivreur(row) {
      try {
        const res = await api.get(`/api/auth/SearchPhone`, {
          params: { type: 2, code: row.code },
        });
        if (res.data.msg === "success") {
          const phone = SubstrPhone(res.data.user.phone);
          const message = [
            `Client : ${row.customer_name}`,
            `Téléphone : ${row.customer_phone}`,
            `Code d'envoi : ${row.code}`,
            `Destinataire : ${row.receiver}`,
            `Téléphone : ${row.phone}`,
            `Ville : ${row.city_name}`,
            `Adresse : ${row.address}`,
            `Commentaire : ${row.note}`,
            `Produit : ${row.product_nature}`,
            `Crbt : ${row.price} ${currency()}`,
          ].join("\n");
          window.open(
            `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
              message
            )}`,
            "_blank"
          );
        }
      } catch (error) {
        console.error("Erreur lors du partage avec livreur :", error);
      }
    }

    // -------------------------------
    // Delete a parcel
    async function Destroy_Coli(row: any) {
      console.log("Deleting parcel:", row);
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const data = new FormData();
          data.append("parcel_id", row.id);
          data.append("parcel_code", row.code);
          try {
            const res = await api.post(`/api/auth/removeParcel`, data);
            if (res.data.message === "success") {
              showToast("Colis supprimé avec succès", "success");
              getRecords();
            } else if (res.data.message === "error") {
              showToast("Vous pouvez pas supprimer ce colis", "error");
            }
          } catch (error) {
            showToast("Erreur lors de la suppression du colis", "error");
          }
        }
      });
    }

    // -------------------------------
    // Force delete a parcel (admin)
    async function adminDestroy(row) {
      console.log("Force deleting parcel:", row);
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const data = new FormData();
          data.append("parcel_id", row.id);
          data.append("parcel_code", row.code);
          try {
            const res = await api.post(`/api/auth/adminRemoveParcel`, data);
            if (res.data.message === "success") {
              showToast("Colis supprimé avec succès", "success");
              getRecords();
            } else if (res.data.message === "error") {
              showToast("Vous pouvez pas supprimer ce colis", "error");
            }
          } catch (error) {
            showToast("Erreur lors de la suppression du colis", "error");
          }
        }
      });
    }

    function hideModal(idModal) {
      const modalEl = document.getElementById(idModal);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      if (modal) {
        modal.hide();
      }
    }

    // -------------------------------
    const rowUpdate = ref(null);
    // Show update modal
    const isOpenEdit = ref(false);
    // Show update modal
    async function showUpdate(row) {
      rowUpdate.value = null;
      isOpenEdit.value = false;
      rowUpdate.value = row;
      nextTick(() => {
        const modalEl = document.getElementById("modal_update");
        if (modalEl) {
          isOpenEdit.value = true; // triggers watcher in child

          const modal = new Modal(modalEl);
          modal.show();
        }
      });
    }

    // -------------------------------
    // Show status modal
    async function showStatus(id) {
      if (
        ((statutColi.value.code === "POSTPONED" ||
          statutColi.value.code === "PROGRAMED") &&
          !date_retour.value) ||
        ((statutColi.value.code === "REFUSE" ||
          statutColi.value.code === "CANCELED" ||
          statutColi.value.code === "OUT_OF_AREA") &&
          !commentStatu.value)
      ) {
        // Do nothing
      } else {
        formStatus.id = 0;
        formStatus.status = "";
        formStatus.status_id = 0;
        formStatus.comment = "";
        statutColi.value = {};
        commentStatu.value = "";
        date_retour.value = "";
        formStatus.id = id;
      }

      const modalEl = document.getElementById("modal_update_status");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    // -------------------------------
    // Edit parcel price
    async function editPrice(row) {
      PriceColis.value = row;
      console.log("Editing price for:", row);
      // TODO: Open price edit modal
    }

    // -------------------------------
    const rowUpdateFees = ref(null);
    // Edit parcel fees
    async function handleFeesClick(row) {
      console.log("Editing fees for:", row);
      rowUpdateFees.value = row;
      const modalEl = document.getElementById("modal_fees_edit");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    // -------------------------------
    // Edit delivered status
    async function EditLivredStatut(row) {
      console.log("Editing delivered status for:", row);
      // TODO: Open delivered status modal
    }

    // -------------------------------
    // Mark parcel as paid
    async function PaidParcel(row) {
      console.log("Marking parcel as paid:", row);
      // TODO: Implement payment logic
    }

    async function editPriceStatut() {
      const data = new FormData();
      data.append("id_colis", String(formStatus.id));
      data.append("status_id", String(statutColi.value?.id ?? ""));
      data.append("status", String(statutColi.value?.code ?? ""));
      data.append("comment", commentStatu.value ?? "");
      data.append(
        "date_report",
        date_retour.value ? moment(date_retour.value).format("DD/MM/YYYY") : ""
      );
      data.append("user_id", String(user?.id ?? ""));

      if (
        (statutColi.value?.code === "REFUSE" ||
          statutColi.value?.code === "CANCELED" ||
          statutColi.value?.code === "OUT_OF_AREA") &&
        !commentStatu.value
      ) {
        showToast("Champs commentaire est obligatoire", "error");
      } else if (
        (statutColi.value?.code === "POSTPONED" ||
          statutColi.value?.code === "PROGRAMED") &&
        !date_retour.value
      ) {
        showToast("Champs date est obligatoire", "error");
      } else {
        api
          .post(`/api/auth/coli_edit_status/${formStatus.id}`, data)
          .then((res) => {
            if (res.data.message === "success") {
              const modalEl = document.getElementById("modal_update_status");
              const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
              modal.hide();
              getRecords();
              showToast("Statut modifié avec succès", "success");
            }
          })
          .catch(() => {
            showToast("Erreur lors de la modification du statut", "error");
          });
      }
    }

    function smsTextreplace(parcel, SMSType) {
      if (SMSType == "DISTRIBUTION") {
        let sms_text = "distribution";
        api
          .post(`/api/auth/sms_msg`, { type: sms_text, parcel: parcel.id })
          .then((res) => {
            if (res.data.msg == "success") {
              window.open(
                "https://api.whatsapp.com/send?phone=" +
                  SubstrPhone(parcel.phone) +
                  "&text=" +
                  res.data.data,
                "_blank"
              );
            }
          });
      } else if (SMSType == "NO_ANSWER") {
        let sms_text = "noanswer";
        api
          .post(`/api/auth/sms_msg`, { type: sms_text, parcel: parcel.id })
          .then((res) => {
            if (res.data.msg == "success") {
              window.open(
                "https://api.whatsapp.com/send?phone=" +
                  SubstrPhone(parcel.phone) +
                  "&text=" +
                  res.data.data,
                "_blank"
              );
            }
          });
      }
    }

    const parcels = ref([]);
    const loading = ref(false);
    const reportedModal = ref(null);

    let modalInstance = null;

    const openReportedToday = async () => {
      // Open modal
      if (!modalInstance) {
        modalInstance = new Modal(reportedModal.value);
      }
      modalInstance.show();

      loading.value = true;
      parcels.value = [];

      try {
        const res = await api.get("/api/auth/ExportTodayReported");
        parcels.value = res.data || [];
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    };

    return {
      leadPlaceholder,
      auth,
      rows,
      goToPage,
      changePerPage,
      paginatedPages,
      filter,
      getDate,
      oldPhone,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      getBadgeConfig,
      zone_filter,
      client_filter,
      liv_filter,
      city_filter,
      status_filter,
      showRefsEdit,
      showRefs,

      etat_filter,
      type_date_filter,
      add_bp_filter,
      ref_filter,
      email_filter,
      price_filter,
      searchTerm,

      clientList,
      zonesList,
      citiesList,
      livreurList,
      etatList,
      status,

      filterClients,
      onSearchDrivers,
      exportColis,
      reportTodayColis,
      countExportToday,

      showParcelBons,
      voirItem,
      user,

      PriceColis,
      TicketsPDF,
      showDetailSuivi,
      showDetails,
      editParcel,
      SubstrPhone,
      ShareCust,
      ShareLivreur,
      Destroy_Coli,
      adminDestroy,
      showUpdate,
      showStatus,
      followupCount,
      toggleFollowupFilter,
      statusFollowupComment,
      editPrice,
      handleFeesClick,
      EditLivredStatut,
      PaidParcel,

      // modals
      minDate,
      statutColi,
      commentStatu,
      date_retour,
      statusList,
      editPriceStatut,

      colisId,
      isOpen,
      coliDetails,
      getRecords,
      rowUpdate,
      rowUpdateFees,

      isLoader,
      smsTextreplace,
      isOpenEdit,
      hideModal,

      openReportedToday,
      reportedModal,
      parcels,
      loading,

      handleInput,

      filtersOpen,
      date_from,
      date_to,
      activeFilterCount,
      applyFilters,
      resetFilters,
      removeOneFilter,
      selectedDate,
      firstDt,
      todayDt,
      showCalendar,
      showCalendarBox,
    };
  },
};
</script>

<style scoped>
/* Suivi et relance des colis: parcels relaunched by the admin */
.relaunch-filter {
  border: 1px solid #1d4ed8;
  color: #1d4ed8;
  font-weight: 600;
}
.relaunch-filter .badge {
  background: #1d4ed8;
  color: #fff;
}
.relaunch-filter.is-active {
  background: #1d4ed8;
  color: #fff;
}
.relaunch-filter.is-active .badge {
  background: #fff;
  color: #1d4ed8;
}
.relaunch-row > th,
.relaunch-row > td {
  border-bottom: 0;
  background: rgba(59, 130, 246, 0.06);
}
.relaunch-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.relaunch-comment-row > td {
  background: rgba(59, 130, 246, 0.06);
}
.relaunch-comment {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border-left: 4px solid #1d4ed8;
  border-radius: 8px;
  background: #fff;
  white-space: normal;
}
.relaunch-comment > i {
  margin-top: 2px;
  color: #1d4ed8;
  font-size: 20px;
}
.relaunch-comment small {
  display: block;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.relaunch-comment p {
  margin: 2px 0 0;
  color: #111827;
  font-size: 14px;
  font-weight: 600;
  white-space: pre-line;
}
</style>
